// extracted by mini-css-extract-plugin
module.exports = {"trial":"Trial_trial___LXnl","trial_full":"Trial_trial_full__jt_OR","trial_short":"Trial_trial_short__feyd3","special":"Trial_special__OUeR7"};